import {useCallback} from 'react';
import useLocalStorage from '../lib/useLocalStorage';

const autoReadStorageKey = 'voice-assistant-auto-read';

/**
 * Whether a reply that lands while the voice session is open is read aloud as
 * it arrives. Off by default: at a desk the reply is already on screen and a
 * full read-out is more disruptive than a missed one, and the voice still
 * announces that the reply is ready so the user can ask for it.
 */
export const useVoiceAutoReadPreference = () => {
    const [storedValue, setStoredValue] = useLocalStorage<boolean>(
        autoReadStorageKey,
        false
    );
    const autoReadEnabled = storedValue === true;

    const setAutoReadEnabled = useCallback(
        (enabled: boolean) => {
            setStoredValue(enabled);
        },
        [setStoredValue]
    );

    return {autoReadEnabled, setAutoReadEnabled};
};
